import close from "../../assets/icons/close.svg";
import "../../assets/css/Modal.css";

export const StudentListForHolidays = ({ isOpen, onClose, students = [], teachers = [] }) => {
    if (!isOpen) return null;

    const handlePrint = () => {
        const printContent = document.getElementById("print-wrapper");
        if (!printContent) return;

        const newWindow = window.open("", "PrintWindow", "width=800,height=1100");
        newWindow.document.write(`
            <html>
              <head>
                <title>Holiday Details</title>
                <style>
                  body { font-family: Arial, sans-serif; padding: 20px; color: #222; background: #fff; }
                  table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
                  th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
                  th { background: #f9f9f9; }
                  h2 { text-align: center; }
                </style>
              </head>
              <body>
                ${printContent.innerHTML}
              </body>
            </html>
        `);
        newWindow.document.close();
        newWindow.focus();
        newWindow.print();
        newWindow.close();
    };

    return (
        <div className="modal-overlay">
            <div
                className="modal-content"
                style={{
                    width: "60%",
                    padding: "20px",
                    maxHeight: "80vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Header */}
                <div className="modal-header-content" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h2 className="text-primary">Holiday Details</h2>
                    <div style={{ display: "flex", gap: "10px" }}>
                        <button className="btn btn-secondary" onClick={handlePrint}>
                            Print
                        </button>
                        <button className="close-btn" onClick={onClose}>
                            <img src={close} alt="close" />
                        </button>
                    </div>
                </div>

                {/* Printable Content */}
                <div id="print-wrapper">
                    {/* Students Table */}
                    {students.length > 0 && (
                        <div style={{ marginTop: "10px" }}>
                            <p><strong>Students:</strong></p>
                            <div style={{ flex: 1, overflowY: "auto", maxHeight: "40vh" }}>
                                <table className="table table-bordered">
                                    <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                                        <tr>
                                            <th>#</th>
                                            <th>Student Name</th>
                                            <th>Registration No</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {students.map((stu, idx) => (
                                            <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>{stu.studentName}</td>
                                                <td>{stu.regNo}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {/* Teachers Table */}
                    {teachers.length > 0 && (
                        <div style={{ marginTop: "20px" }}>
                            <p><strong>Teachers:</strong></p>
                            <div style={{ flex: 1, overflowY: "auto", maxHeight: "40vh" }}>
                                <table className="table table-bordered">
                                    <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                                        <tr>
                                            <th>#</th>
                                            <th>Teacher Name</th>
                                            <th>Teacher Code</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {teachers.map((tch, idx) => (
                                            <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>{tch.teacherName}</td>
                                                <td>{tch.teacherCode}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
